import React, { useEffect, useState } from "react";
import ReviewService from "../../../services/ReviewService";
import { IReviewsList } from "../../../helpers/types/global";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { Modal } from "antd";
import TabAddReview from "./TabAddReview";
import {
  MsgError,
  MsgSuccess,
} from "../../../components/Loaders/MessageLoaders";
import DeleteAlert from "../../page-essential/DeleteAlert";

const tableHeaders = [
  {
    id: 0,
    title: "category",
  },
  {
    id: 1,
    title: "reviews name",
  },
  {
    id: 2,
    title: "address",
  },
  {
    id: 3,
    title: "rating",
    img: true,
  },
  {
    id: 4,
    title: "package",
  },
  {
    id: 5,
    title: "Actions",
  },
];

const TabViewReview = () => {
  const [data, setData] = useState<IReviewsList[]>([]);
  const initialSelectedReview = {
    id: "",
    action: "",
    modal: false,
  };
  const [selectedReview, setSelectedReview] = useState<{
    id: string;
    action: string;
    modal: boolean;
  }>(initialSelectedReview);

  const fetchReviews = async () => {
    try {
      const res = await ReviewService.fetchReviews();
      setData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveReview = async (id: string) => {
    try {
      const res = await ReviewService.deleteReview(id);
      MsgSuccess(res.data.message);
      setSelectedReview(initialSelectedReview);
      fetchReviews();
    } catch (error: any) {
      if (error.response) {
        MsgError(error.response.data.message || "Error while deleting review.");
      }
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);
  return (
    <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr className="h-12">
            <th className="px-3" scope="col">
              #
            </th>
            {tableHeaders.map((item: any, i: number) => {
              return (
                <th key={i} className="capitalize" scope="col">
                  {item.title.replaceAll("_", " ")}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="text-[16px]">
          {data.map((item, i) => (
            <tr
              key={item.id}
              className="h-12 border-b border-b-gray-300  transition-all hover:shadow-md"
            >
              <td>{i + 1}</td>
              <td>{item.review_category.review_category_name}</td>
              <td>{item.name}</td>
              <td>{item.address}</td>
              <td className="font-bold text-primary-base">{item.rating}</td>
              <td>{item.pkg.title}</td>

              <td className="">
                {/* props.actions.handleEdit */}
                <div className="flex items-center space-x-4">
                  <div
                    className="cursor-pointer hover:text-primary"
                    onClick={() => {
                      setSelectedReview({
                        id: item.id,
                        action: "edit",
                        modal: true,
                      });
                    }}
                  >
                    <FaEdit />
                  </div>

                  <div
                    className="cursor-pointer hover:text-error"
                    onClick={() => {
                      setSelectedReview({
                        id: item.id,
                        action: "delete",
                        modal: true,
                      });
                    }}
                  >
                    <FaTrashAlt />
                  </div>

                  {/* {props.actions?.translation && (
                    <div
                      className="cursor-pointer hover:text-error bg-green-500 p-2 text-white rounded-md"
                      onClick={() =>
                        props.actions?.translation &&
                        props.actions?.translation(data.id)
                      }
                    >
                      Translate
                    </div>
                  )} */}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedReview?.modal && selectedReview.action === "edit" ? (
        <Modal
          open={selectedReview.modal}
          title={"Edit Review"}
          keyboard
          onCancel={() => setSelectedReview(initialSelectedReview)}
          footer={null}
        >
          <TabAddReview
            editReviewWithId={selectedReview.id}
            fetchReview={fetchReviews}
          />
        </Modal>
      ) : (
        ""
      )}

      {selectedReview.modal && selectedReview.action === "delete" ? (
        <DeleteAlert
          setModalOpen={() => setSelectedReview(initialSelectedReview)}
          handleDelete={() => handleRemoveReview(selectedReview.id)}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default TabViewReview;
